import React from "react";
import {ShowcaseItemsView} from "./profile/Components";
import {ShowcaseItem} from "./types";
import {BaseTitleFragment, BaseTitleFragmentProps, BaseTitleFragmentState} from "./BaseTitleFragment";
import {LoginSpec} from "../shared/PageFragment";
import {EmptyConfig} from "../shared/types";
import {FollowTheSignsOutlined} from "@mui/icons-material";

export type FollowingFragmentProps = BaseTitleFragmentProps&{}

type FollowingFragmentState = BaseTitleFragmentState&{
  items: ShowcaseItem[],
}

export class FollowingFragment extends BaseTitleFragment<FollowingFragmentProps,FollowingFragmentState> {

  protected getTitle(): string {
    return "Following";
  }

  protected createLoginSpec(): LoginSpec | null {
    return {
      needsLogin: true,
      redirectAfterLoginPath: "/following",
    };
  }

  protected getEmptyConfig(): EmptyConfig {
    return {
      title: "Nothing to see here",
      text: "Follow your favorite users and the items they post will show up here.",
      iconType: FollowTheSignsOutlined,
    };
  }

  protected renderPageContent(): React.ReactElement {
    if (!(this.state.items?.length > 0)) {
      return this.renderEmpty();
    }
    return <>
      <ShowcaseItemsView path={this.props.path} items={new Array(12).fill("_").map(val => ShowcaseItem.PLACEHOLDER)}/>
    </>;
  }
}